<template>
  <div class="h-full">
    <el-container class="h-full" v-loading="loading">
      <el-aside
        @click.native.stop
        width="290px"
        class="pt-3 bg-white border-r border-solid border-theme-text-gray border-opacity-10"
      >
        <el-scrollbar class="h-full" wrap-class="overflow-x-hidden">
          <LeftAside @add="onAdd" />
        </el-scrollbar>
      </el-aside>
      <el-main class="p-0 edit relative bg-bg-common-color edit-container" ref="scrollContainer">
        <!-- <div class="draft_info" v-if="isPublishing && isDraft">
          <i class="el-icon-warning-outline mr-1 text-medium-x"></i>
          <p class="text-small">
            代理商信息收集表已被修改，修改内容在版本更新前将处于草稿状态，代理商不会以该版本收集数据，如需 使用当前代理商请
            <span class="text-theme select-none cursor-pointer" @click="updateQuestion">更新</span>
            调查员
          </p>
        </div> -->
        <section :class="['w-full', 'px-6', 'box-border', isPublishing && isDraft ? '' : 'pt-6']">
          <div class="mb-6">
            <title-and-welcome></title-and-welcome>
          </div>
          <div class="question-group" ref="questionList">
            <draggable animation="600" :value="questionList" @end="onMoveEnd" handle=".question-move-class">
              <transition-group>
                <SectionQuestion
                  v-for="item in questionList"
                  :key="item.q_id"
                  :question="item"
                  @update="onUpdate(item)"
                  @remove="onRemove(item)"
                ></SectionQuestion>
              </transition-group>
            </draggable>
          </div>
        </section>
      </el-main>
      <el-aside class="absolute right-0 top-0 bottom-0 pt-3 edit-setting-aside" width="290" @click.native.stop>
        <el-scrollbar class="h-full" wrap-class="overflow-x-hidden">
          <Setting class="px-4" @on-update="onUpdate" />
        </el-scrollbar>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
import LeftAside from './components/LeftAside'
import TitleAndWelcome from '@/views/survey/edit/TitleAndWelcome'
import SectionQuestion from './components/SectionQuestion'

import { createQuestion, normalizeNum } from '@/question/factory'
import { surveyLoading } from '@/assets/js/el-loading'
import Setting from './components/Setting'
import { SET_SELECT_QUESTION, SET_QUESTION_LIST } from '@/store/survey/mutation-types'
import { isPage, isQuestionGroup } from '@/assets/js/question-util'
import { TO_QUESTION_POS, REMOVE_QUESTION_LIST, MOVE_QUESTION_LIST } from '@/assets/js/config/bus'
import { mapGetters, mapActions } from 'vuex'
import { add } from '@/api/question'
import { getSurveyById } from '@/api/survey'
import { update } from '@/question/operate'

import GlobalConfig from '@/global/config'
import { checkMove } from '@/question/util'
import Draggable from 'vuedraggable'
import { createWj } from '@/api/wenjuan/wjquestion'
import { getFreeLink, openPublishWj, saveBrowserMaxAnswerNum } from '@/api/wenjuan/publish'
import { PostMessage } from '@dygc/shared'

export default {
  name: 'BankEditQuestion',
  components: { LeftAside, TitleAndWelcome, SectionQuestion, Draggable, Setting },
  data() {
    return {
      loading: false,
      chlistener: null,
      isDraft: false,
      isLastRelease: false,
      publishStatus: null,
      isPublishing: false
    }
  },
  created() {
    this.init()
  },
  computed: {
    isQs() {
      return this.questionList.length > 0
    },
    // surveyId() {
    //   return this.$route.query.surveyId
    // },
    isAdmin() {
      return this.$store.getters.userInfo?.isAdmin == 1
    },
    ...mapGetters(['questionList'])
  },
   methods: {
    init() {
      this.$surveyBus.$on(TO_QUESTION_POS, this.refreshScrollTop)
      this.$surveyBus.$on(REMOVE_QUESTION_LIST, this.mulReMove)
      this.$surveyBus.$on(MOVE_QUESTION_LIST, this.mulMove)

      console.log('GlobalConfig', GlobalConfig.getSurveyId())
      // if (GlobalConfig.getSurveyId()) {
        // GlobalConfig.setSurveyId( this.surveyId )
        this.initSurvey()
      // } else {
        // this.createSurvey()
      // }
    },
    // async createSurvey() {
    //   try {
    //     const {
    //       data: { data: survey }
    //     } = await createWj('请填写问卷调查标题', null)
    //     const surveyId = survey.id
    //     GlobalConfig.setSurveyId(surveyId)
    //     saveBrowserMaxAnswerNum(surveyId, { browserMaxAnswerNum: 0 })
    //     await openPublishWj(surveyId)
    //     let { data: channel } = await getFreeLink({ channelType: '0', surveyId })
    //     const msg = new PostMessage('*')
    //     msg.sendMessage('createSurvey', { surveyId, answerChannelId: channel?.data[0]?.id })
    //     this.initSurvey()
    //     this.loading = false
    //   } catch (e) {
    //     this.loading = false
    //   }
    // },
    initSurvey() {
      getSurveyById(GlobalConfig.getSurveyId()).then(res => {
        this.$store.dispatch('initSurvey', res.data.data)
      })
    },
    mulReMove(questionList = [], cb) {
      let normalList = []
      let groupList = []
      for (const q of questionList) {
        normalList.push(q)
      }
      const ids = []
      for (const q of normalList) {
        ids.push(q.id)
      }
      surveyLoading(() => {
        return this.removeQuestionAdapter(ids, !!groupList.length).then(() => {
          cb && cb(true)
        })
      })
    },
    //添加
    onAdd(item) {
      createQuestion(item.value).then(question => {
        // question.type = Type.CONTROL
        question.is_required = false
        this.$store.commit(SET_SELECT_QUESTION, question)
        this.add([question])
      })
    },
    add(list = []) {
      let questionList = this.questionList.slice()
      const preQuestionId = questionList[questionList.length - 1]?.id ?? null
      const data = {
        id: GlobalConfig.getSurveyId(),
        questions: list.map(i => i.getParams()),
        preQuestionId
      }
      add(data).then(res => {
        let ids = res.data.data
        list.forEach((q, idx) => {
          q.id = ids[idx]
        })
        questionList.push(...list)
        normalizeNum(questionList)
        this.$store.commit(SET_QUESTION_LIST, questionList)
      })
    },
    onMoveEnd(v) {
      this.onMove(v)
    },
    openWarningMsgBox(message) {
      this.$msgbox({
        title: '警告',
        type: 'warning',
        confirmButtonText: '确定',
        showCancelButton: false,
        message: message
      })
    },
    // 移动
    onMove(v, cb) {
      let { newIndex, oldIndex } = v
      if (newIndex === oldIndex) return
      if (newIndex < 0) newIndex = 0
      let list = this.questionList.slice()
      let element = list[oldIndex]
      list.splice(oldIndex, 1)
      list.splice(newIndex, 0, element)

      let centerList = []

      if (oldIndex > newIndex) {
        centerList = list.slice(newIndex + 1, oldIndex + 1)
      } else {
        centerList = list.slice(oldIndex, newIndex)
      }
      let checkResult = checkMove(element, centerList)
      if (!checkResult.success) {
        this.openWarningMsgBox(checkResult.message)
        return
      }
      this.moveQuestionList({
        surveyId: GlobalConfig.getSurveyId(),
        preQuestionId: list[newIndex - 1]?.id || null,
        questionIds: [element.id],
        list
      }).then(() => {
        if (typeof cb === 'function') {
          cb()
        }
      })
    },
    mulMove(v, cb) {
      let { newIndex, oldIndexList = [] } = v
      const questionList = this.questionList.slice()
      for (const index of oldIndexList) {
        let list = questionList.slice()
        const element = list[index]
        list.splice(newIndex, 0, ...list.splice(index, 1))
        let centerList
        if (index > newIndex) {
          centerList = list.slice(newIndex + 1, index + 1)
        } else {
          centerList = list.slice(index, newIndex)
        }
        let checkResult = checkMove(element, centerList, this.multipleLogicList, this.logicList)
        if (!checkResult.success) {
          this.openWarningMsgBox(checkResult.message)
          cb && cb(false)
          return
        }
      }

      const appendList = []
      for (const index of oldIndexList) {
        appendList.push(questionList[index])
        questionList[index] = null
      }
      const preQuestionId = this.questionList[newIndex]?.id || null
      questionList.splice(newIndex + 1, 0, ...appendList)

      const finalList = questionList.filter(q => q !== null)
      
      const list = this.questionList.slice()
      let isNeedMove = false
      for (let i = 0; i < list.length; i++) {
        if (list[i].id !== finalList[i].id) {
          isNeedMove = true
        }
      }

      if (!isNeedMove) {
        cb && cb(true)
        return
      }

      this.moveQuestionList({
        surveyId: GlobalConfig.getSurveyId(),
        preQuestionId: preQuestionId,
        questionIds: appendList.map(q => q.id),
        list: finalList
      }).then(() => {
        if (typeof cb === 'function') {
          cb(true)
        }
      })
    },
    //编辑
    onUpdate(question) {
      update(question)
    },
    //单个删除
    onRemove(question) {
      return this.$confirm('确定要删除吗？', '删除题目确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'normal-button',
        confirmButtonClass: 'normal-button'
      }).then(() => {
        this.$store.commit(SET_SELECT_QUESTION, null)
        surveyLoading(() => {
          return this.removeQuestionAdapter([String(question.id)], false)
        })
      })
    },
    removeQuestionAdapter(ids = [], isGroup) {
      let finalIds = ids
      let list = this.questionList.slice()
      let finalList = list.filter(q => !ids.includes(q.id))
      let tmp = finalList.shift()
      while (isPage(tmp)) {
        finalIds.push(tmp.id)
        tmp = finalList.shift()
      }
      let pageList = finalList.filter(isPage)
      let last = finalList.pop()
      if (pageList.length === 1 && isPage(last)) {
        finalIds.push(last.id)
      }

      return this.removeQuestionByIds({
        surveyId:  GlobalConfig.getSurveyId(),
        ids: finalIds,
        group: isGroup
      })
    },
    //定位
    refreshScrollTop(q) {
      let list
      let toEl
      if (isQuestionGroup(q)) {
        list = this.$refs.questionList.getElementsByClassName('question-item-group')
      } else {
        list = this.$refs.questionList.getElementsByClassName('question-item')
      }
      let len = list.length
      for (let i = len - 1; i >= 0; i--) {
        let el = list[i]
        let id = el.getAttribute('data-id')
        if (q.q_id.toString() === id) {
          toEl = el
          break
        }
      }
      if (!toEl) return
      let scrollContainer = this.$refs.scrollContainer.$el
      scrollContainer.scrollTop = toEl.offsetTop
    },
    ...mapActions(['removeQuestionByIds', 'moveQuestionList']),
  },
  beforeDestroy() {
    this.$surveyBus.$off(TO_QUESTION_POS, this.refreshScrollTop)
    this.$surveyBus.$off(REMOVE_QUESTION_LIST, this.mulReMove)
    this.$surveyBus.$off(MOVE_QUESTION_LIST, this.mulMove)
  }
}
</script>
